import { useListStore } from '../../hooks';
import { TaskListView } from '../../components/TaskListView';

export const TaskList = () => {
  const { releaseTasks, onOpenModal } = useListStore();

  return (
    <TaskListView listItems={releaseTasks} handleEditOpenModal={onOpenModal} />
  );
};
